var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutoresponderTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 28.27 25.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-5{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#c6d1d5;}.cls-4{fill:#39af4f;fill-rule:evenodd;}.cls-5{stroke:#39af4f;stroke-miterlimit:10;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 28.27,
    height: 25.27
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22,11.7s.05.62.05.94A9.48,9.48,0,1,1,18.8,5.56a.07.07,0,0,0,.1,0l2-2a.09.09,0,0,0,0-.12A12.43,12.43,0,1,0,13.67,25a12.53,12.53,0,0,0,11-9.54,12.22,12.22,0,0,0-.14-6.23.06.06,0,0,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13.07,14.23,8.55,9.7a1,1,0,0,0-1.34,0l-.43.42a.94.94,0,0,0,0,1.33l5.63,5.63a.93.93,0,0,0,1.32,0L27.36,3.47a1,1,0,0,0,0-1.34l-.4-.41a1,1,0,0,0-1.35,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M13.07,14.23,8.55,9.7a1,1,0,0,0-1.34,0l-.43.42a.94.94,0,0,0,0,1.33l5.63,5.63a.93.93,0,0,0,1.32,0L27.36,3.47a1,1,0,0,0,0-1.34l-.4-.41a1,1,0,0,0-1.35,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoresponderTick);
export default __webpack_public_path__ + "static/media/autoresponder-tick.d09ce7209bc274e29f8b8776ce60856c.svg";
export { ForwardRef as ReactComponent };